import "./global.css";
import "./theme/theme.css";
import "./locales/i18n";

import { OidcProvider } from "@axa-fr/react-oidc";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router";
import App from "./App";
import { DialogProvider } from "./components/dialog";
import { registerLocalIcons } from "./components/icon";
import { GLOBAL_CONFIG } from "./global-config";
import { AuthenticatingError, configuration, LoadingComponent, SessionLost } from "./oidc";
import { initRequestClient } from "./request";
import ErrorBoundary from "./routes/components/error-boundary";
import { routesSection } from "./routes/sections";

initRequestClient();

await registerLocalIcons();

const router = createBrowserRouter(
  [
    {
      Component: () => (
        <DialogProvider>
          <App>
            <Outlet />
          </App>
        </DialogProvider>
      ),
      errorElement: <ErrorBoundary />,
      children: routesSection,
    },
  ],
  {
    basename: GLOBAL_CONFIG.publicPath,
  },
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <OidcProvider
    configuration={configuration}
    loadingComponent={LoadingComponent}
    authenticatingErrorComponent={AuthenticatingError}
    sessionLostComponent={SessionLost}
  >
    <RouterProvider router={router} />
  </OidcProvider>,
);
